exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul.arrow-square[data-v-339b0776],ul.arrow[data-v-339b0776],ul.check-circle[data-v-339b0776],ul.check-square[data-v-339b0776],ul.check[data-v-339b0776],ul.chevron[data-v-339b0776],ul.circle[data-v-339b0776],ul.decimal[data-v-339b0776],ul.lower-latin[data-v-339b0776],ul.triangle[data-v-339b0776],ul.upper-latin[data-v-339b0776],ul.upper-roman[data-v-339b0776]{font-size:1.0833em}@media only screen and (min-device-width:768px) and (max-device-width:1024px){h1[data-v-339b0776]{font-size:1.6em}.booking-information[data-v-339b0776]{padding:20px 30px 30px;padding:20px 15px 30px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-339b0776","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/infos/dangerous-goods/Home.vue
// module id = 578
// module chunks = 0